var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "#E51A3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1956_4480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4993 25.6307C35.5729 25.6307 37.5594 26.4587 39.0248 27.9354C40.4888 29.4107 41.3132 31.4131 41.3132 33.5019C41.3132 37.8488 37.8151 41.37 33.4993 41.37C31.4278 41.3723 29.4406 40.5428 27.9737 39.0653C26.5097 37.5901 25.6861 35.5884 25.6861 33.5019C25.6861 31.4154 26.509 29.4107 27.9737 27.9354C29.4406 26.4595 31.4286 25.6292 33.5 25.6307H33.4993ZM33.4993 22C23.0556 22 17 30.6227 17 33.5019C17 36.3811 23.0556 45.0007 33.4993 45.0007C43.9429 45.0007 50 36.3803 50 33.5019C50 30.6234 43.9467 22 33.4993 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3495 33.5017C38.3495 35.8552 36.6918 37.8794 34.3967 38.3264C32.1017 38.7741 29.8141 37.5186 28.9412 35.3354C28.0691 33.1507 28.8577 30.6502 30.8211 29.3737C32.7837 28.0942 35.3724 28.3995 36.99 30.099L33.4695 33.5032H38.3495V33.5017Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1956_4480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 23,
    fill: "white",
    transform: "translate(17 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.73a9774bce6d64ade62e02ef884abbfd.svg";
export { ForwardRef as ReactComponent };